import { Subject } from "rxjs";

const CannedMessageSubject = new Subject();

const CannedMessageService = {
  listen: () => CannedMessageSubject.asObservable(),
  copyCannedMessage: (message) => CannedMessageSubject.next(message),
};

export default CannedMessageService;
